import { Injectable } from '@angular/core';
import { BehaviorSubject, filter } from 'rxjs';
import { UserService } from '../services/user/user.service';
import { Menu } from './menu.component';
import { PermissaoEnum } from '../../models/role.enum';
import { NavigationEnd, Router } from '@angular/router';
import { NavbarService } from '../navbar/navbar.service';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  _menu = new BehaviorSubject<Menu[]>([]);
  loading = new BehaviorSubject<boolean>(false);
  private readonly STORAGE_KEY = 'menu-loading';
  private _loading = new BehaviorSubject<boolean>(this.getInitialValue());
  loading$ = this._loading.asObservable();

  constructor(
    private readonly userService: UserService,
    private readonly router: Router,
    private readonly navbarService: NavbarService,
  ) {
    this.updateMenu();
    this.listenChangeRouter();
  }

  private listenChangeRouter(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const navEndEvent = event as NavigationEnd;
        let currentRoute: string = navEndEvent.urlAfterRedirects;
        currentRoute =
          '/' + currentRoute.split('/').filter(Boolean).slice(0, 2).join('/');
        this.setMenuSelected(currentRoute);
        this.setTitleFromNavbar(currentRoute);
      });
  }

  private setMenuSelected(currentUrl: string): void {
    this.selectCurrentMenu(currentUrl);
  }

  private setTitleFromNavbar(currentUrl: string): void {
    const menu: Menu[] = this.getCurrentMenuList();

    const [currentMenu] = menu.filter((currentMenu) =>
      currentMenu.route.startsWith(currentUrl),
    );

    this.navbarService.title = currentMenu?.label ?? 'Rota não cadastrada';
  }

  private getCurrentMenuList(): Menu[] {
    let newMenuList: Menu[] = [];

    /**
     * @todo - check how get menu list more easily
     */
    this._menu.subscribe((menu) => (newMenuList = menu));

    return newMenuList;
  }

  setLoading(value: boolean) {
    this._loading.next(value);
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(value));
  }

  private getInitialValue(): boolean {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    return stored ? JSON.parse(stored) : true; // valor padrão se não existir
  }

  setMenu(menu: Menu[]) {
    this._menu.next(menu);
  }

  /**
   * @deprecated - is not necessary call manually more the menu are select automatic
   * @todo - remove this method on the future when refactor all system
   * @todo - remove this method from your class
   * @param menu
   */
  setSelected(menu?: Menu) {
    return;
    // let lista: Menu[] = [];
    //
    // this._menu.subscribe((menu) => (lista = menu));
    //
    // lista = lista.map((item) => {
    //   if (item.checked) {
    //     item.checked = false;
    //   }
    //   if (menu && item.label == menu.label) {
    //     item.checked = true;
    //   }
    //   return item;
    // });
    // this._menu.next(lista);
  }

  selectCurrentMenu(pathUrl: string): void {
    let newMenuList: Menu[] = this.getCurrentMenuList();

    newMenuList = newMenuList.map((menu) => ({
      ...menu,
      checked: menu.route.startsWith(pathUrl),
    }));

    this._menu.next(newMenuList);
  }

  getMenu(): Menu[] {
    return this._menu.getValue();
  }

  updateMenu() {
    const role = this.userService.permissaoRole;
    if (role) {
      switch (this.userService.permissaoRole.id) {
        case PermissaoEnum.ROLE_ADMIN:
          return this._menu.next([
            {
              icon: 'home',
              label: 'Inicio',
              route: '/admin/home',
              checked: false,
            },
            // {
            //   icon: 'dashboard',
            //   label: 'Dashboard',
            //   route: '/admin/escola',
            //   checked: false,
            // },
            {
              icon: 'local_library',
              label: 'Escolas',
              route: '/admin/escolas',
              checked: false,
            },
            {
              icon: 'meeting_room',
              label: 'Turmas',
              route: '/admin/turmas',
              checked: false,
            },
            {
              icon: 'badge',
              label: 'Colaboradores',
              route: '/admin/colaboradores',
              checked: false,
            },
            {
              icon: 'school',
              label: 'Alunos',
              route: '/admin/alunos',
              checked: false,
            },
            {
              icon: 'calendar_month',
              label: 'Agenda',
              route: '/admin/agenda',
              checked: false,
            },
            {
              icon: 'local_library',
              label: 'Cursos',
              route: '/admin/cursos',
              checked: false,
            },
            {
              icon: 'library_books',
              label: 'Matérias',
              route: '/admin/materias',
              checked: false,
            },
            {
              icon: 'assignment',
              label: 'Plano de Aula',
              route: '/admin/plano-aula',
              checked: false,
            },
            {
              icon: 'schedule',
              label: 'Grade Horária',
              route: '/admin/grade-horaria',
              checked: false,
            },
            {
              icon: 'topic',
              label: 'Relatórios',
              route: '/admin/relatorios',
              checked: false,
            },
            // {
            //   icon: 'airport_shuttle',
            //   label: 'Rastreamento',
            //   route: '/admin/rastreamento',
            //   checked: false,
            // },
            // {
            //   icon: 'handyman',
            //   label: 'Gestão de Obras',
            //   route: '/admin/gestao-obras',
            //   checked: false,
            // },
            // {
            //   icon: 'soup_kitchen',
            //   label: 'Merenda escolar',
            //   route: '/admin/merenda-escolar',
            //   checked: false,
            // },
            // {
            //   icon: 'chat_bubble',
            //   label: 'Chat',
            //   route: '/admin/chat',
            //   checked: false,
            // },
            // {
            //   icon: 'assignment',
            //   label: 'Pesquisas',
            //   route: '/admin/pesquisas',
            //   checked: false,
            // },
            // {
            //   icon: 'nest_cam_wired_stand',
            //   label: 'Central',
            //   route: '/admin/central',
            //   checked: false,
            // },
            // {
            //   icon: 'help',
            //   label: 'Suporte',
            //   route: '/admin/suporte',
            //   checked: false,
            // },
          ]);
        case PermissaoEnum.ROLE_DIRETOR:
          return this._menu.next([
            {
              icon: 'home',
              label: 'Inicio',
              route: '/admin/home',
              checked: false,
            },
            {
              icon: 'local_library',
              label: 'Escolas',
              route: '/admin/escolas',
              checked: false,
            },
            {
              icon: 'library_books',
              label: 'Matérias',
              route: '/admin/materias',
              checked: false,
            },
            {
              icon: 'local_library',
              label: 'Cursos',
              route: '/admin/cursos',
              checked: false,
            },
            {
              icon: 'badge',
              label: 'Colaboradores',
              route: '/admin/colaboradores',
              checked: false,
            },
            {
              icon: 'school',
              label: 'Alunos',
              route: '/admin/alunos',
              checked: false,
            },
            {
              icon: 'meeting_room',
              label: 'Turmas',
              route: '/admin/turmas',
              checked: false,
            },
            {
              icon: 'calendar_month',
              label: 'Agenda',
              route: '/admin/agenda',
              checked: false,
            },
            {
              icon: 'schedule',
              label: 'Grade Horária',
              route: '/admin/grade-horaria',
              checked: false,
            },
            {
              icon: 'topic',
              label: 'Relatórios',
              route: '/admin/relatorios',
              checked: false,
            },
            // {
            //   icon: 'airport_shuttle',
            //   label: 'Rastreamento',
            //   route: '/admin/rastreamento',
            //   checked: false,
            // },
            // {
            //   icon: 'handyman',
            //   label: 'Gestão de Obras',
            //   route: '/admin/gestao-obras',
            //   checked: false,
            // },
            // {
            //   icon: 'soup_kitchen',
            //   label: 'Merenda escolar',
            //   route: '/admin/merenda-escolar',
            //   checked: false,
            // },
            // {
            //   icon: 'chat_bubble',
            //   label: 'Chat',
            //   route: '/admin/chat',
            //   checked: false,
            // },
            // {
            //   icon: 'assignment',
            //   label: 'Pesquisas',
            //   route: '/admin/pesquisas',
            //   checked: false,
            // },
            // {
            //   icon: 'nest_cam_wired_stand',
            //   label: 'Central',
            //   route: '/admin/central',
            //   checked: false,
            // },
            // {
            //   icon: 'help',
            //   label: 'Suporte',
            //   route: '/admin/suporte',
            //   checked: false,
            // },
          ]);
        case PermissaoEnum.ROLE_SECRETARIO:
          return this._menu.next([
            {
              icon: 'home',
              label: 'Inicio',
              route: '/admin/home',
              checked: false,
            },
            {
              icon: 'meeting_room',
              label: 'Turmas',
              route: '/admin/turmas',
              checked: false,
            },
            {
              icon: 'school',
              label: 'Alunos',
              route: '/admin/alunos',
              checked: false,
            },
            {
              icon: 'local_library',
              label: 'Cursos',
              route: '/admin/cursos',
              checked: false,
            },
            {
              icon: 'library_books',
              label: 'Matérias',
              route: '/admin/materias',
              checked: false,
            },
            {
              icon: 'schedule',
              label: 'Grade Horária',
              route: '/admin/grade-horaria',
              checked: false,
            },
            {
              icon: 'topic',
              label: 'Relatórios',
              route: '/admin/relatorios',
              checked: false,
            },
            {
              icon: 'calendar_month',
              label: 'Agenda',
              route: '/admin/agenda',
              checked: false,
            },
            // {
            //   icon: 'airport_shuttle',
            //   label: 'Rastreamento',
            //   route: '/admin/rastreamento',
            //   checked: false,
            // },
            // {
            //   icon: 'handyman',
            //   label: 'Gestão de Obras',
            //   route: '/admin/gestao-obras',
            //   checked: false,
            // },
            // {
            //   icon: 'soup_kitchen',
            //   label: 'Merenda escolar',
            //   route: '/admin/merenda-escolar',
            //   checked: false,
            // },
            // {
            //   icon: 'chat_bubble',
            //   label: 'Chat',
            //   route: '/admin/chat',
            //   checked: false,
            // },

            // {
            //   icon: 'help',
            //   label: 'Suporte',
            //   route: '/admin/suporte',
            //   checked: false,
            // },
          ]);
        case PermissaoEnum.ROLE_PROFESSOR:
          return this._menu.next([
            {
              icon: 'home',
              label: 'Inicio',
              route: '/admin/home',
              checked: false,
            },
            {
              icon: 'meeting_room',
              label: 'Turmas',
              route: '/admin/turmas',
              checked: false,
            },
            {
              icon: 'school',
              label: 'Alunos',
              route: '/admin/alunos',
              checked: false,
            },
          ]);
        case PermissaoEnum.ROLE_RESPONSAVEL:
          return this._menu.next([
            {
              icon: 'check_circle',
              label: 'Notas',
              route: '/admin/notas',
              checked: false,
            },
            {
              icon: 'schedule',
              label: 'Frequência',
              route: '/admin/frequencia-aluno',
              checked: false,
            },
            {
              icon: 'error',
              label: 'Observações',
              route: '/admin/likes-deslikes',
              checked: false,
            },
            {
              icon: 'calendar_month',
              label: 'Agenda',
              route: '/admin/agenda',
              checked: false,
            },
            {
              icon: 'tab',
              label: 'Dados do Aluno',
              route: '/admin/dados-aluno',
              checked: false,
            },
            {
              icon: 'local_hospital',
              label: 'Ficha Médica',
              route: '/admin/ficha-medica',
              checked: false,
            },
            {
              icon: 'history',
              label: 'Histórico',
              route: '/admin/historico-aluno',
              checked: false,
            },
            {
              icon: 'docs',
              label: 'Documentos',
              route: '/admin/documentos-aluno',
              checked: false,
            },
          ]);
        default:
          return this._menu.next([
            {
              icon: 'home',
              label: 'Inicio',
              route: '/admin/home',
              checked: true,
            },
            {
              icon: 'local_library',
              label: 'Escolas',
              route: '/admin/escolas',
              checked: false,
            },
            {
              icon: 'gavel',
              label: 'Termos',
              route: '/admin/termos',
              checked: false,
            },
          ]);
      }
    }
  }
}
